import { LogBuffer as SERVICE_WORKER_LogBuffer } from '../../../../ServiceWorker/src/helpers/log-buffer';

export { SERVICE_WORKER_LogBuffer as LogBuffer };
